import {RegistratioData} from '../../../../model/registration-data';
import {TrackInfo} from './track-info';

export class TrackActionResult{

  constructor(data: RegistratioData, nextRoute?: TrackInfo, newTrack?: TrackInfo[]) {
    this.data = data;
    this.nextRoute = nextRoute;
    this.newTrack = newTrack;
  }

  data: RegistratioData;
  nextRoute: TrackInfo;
  newTrack: TrackInfo[];

}
